import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { dasa } from 'src/classess/dasaClasses';

/**
 * The floating "Need help?" widget on the customer storefront.
 *
 * <p>Where it points depends on the store. A store that has set its own
 * WhatsApp number under Store Configurations gets messaged directly; only a
 * store that hasn't falls back to DASA support. A customer chasing an order is
 * asking the restaurant, not the platform — routing them to us means we relay
 * a question we cannot answer.
 */
@Component({
    selector: 'app-chat-box',
    templateUrl: './chat-box.component.html',
    styleUrls: ['./chat-box.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatBoxComponent implements OnInit {

  /** Used only when the store has configured no number of its own. */
  private static readonly DASA_SUPPORT_NUMBER = '447565176435';

  isClosed: boolean = false;

  /** The store's number, digits only, or '' when it hasn't set one. */
  private get storeNumber(): string {
    const raw = dasa.Utility.storeConfigurations?.contactMobile;
    if (!raw) return '';
    // Accept whatever the vendor typed — 07…, +44…, spaces and brackets — and
    // normalise to the digits wa.me expects. A leading 0 is a local UK number,
    // so it becomes 44 rather than being sent as-is.
    let digits = String(raw).replace(/[^0-9]/g, '');
    if (!digits) return '';
    if (digits.startsWith('0')) digits = '44' + digits.replace(/^0+/, '');
    return digits;
  }

  get messagingStore(): boolean {
    return !!this.storeNumber;
  }

  /** What the button says — the store's name when we're messaging the store. */
  get supportLabel(): string {
    if (!this.messagingStore) return 'DASA Support';
    const name = dasa.Utility.selectedStoreDetails?.[0]?.name;
    return name ? String(name) : 'Message us';
  }

  get supportSubtitle(): string {
    return this.messagingStore ? 'Chat with us on WhatsApp' : 'Chat with DASA Support';
  }

  constructor() { }

  ngOnInit(): void {
  }

  openWhatsApp() {
    const number = this.storeNumber || ChatBoxComponent.DASA_SUPPORT_NUMBER;
    const text = this.messagingStore
      ? 'Hello, I have a question about my order'
      : 'Hello Dasa Support';
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(text)}`, '_blank');
  }

  closeChatBox() {
    this.isClosed = true;
  }

  openChatBox() {
    this.isClosed = false;
  }
}
